// extracted by mini-css-extract-plugin
export default {"msgRow":"message_msgRow__W47V9","MiddleRow":"message_MiddleRow__54OAd"};